import { ProgressLayout } from 'ipro-ui-kit-vuejs/src/layouts';
import { mapGetters } from 'vuex';

import { LogoutService } from '@/core/logout';
import { ContainerMixin } from '@/core/mixins';

import HelpCentre from '@/portal/help-centre/HelpCentre.vue';
import FeedbackPopup from '@/portal/feedback-popup/FeedbackPopup.vue';

// @vue/component
export default {
  components: {
    ProgressLayout,
    HelpCentre,
    FeedbackPopup,
  },
  mixins: [
    ContainerMixin,
  ],
  data() {
    return {
      showingFeedback: false,
    };
  },
  computed: {
    ...mapGetters(['userFullName']),
    showBottomAdditionalToolbar() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },
  methods: {
    logout: LogoutService.logout,
    showFeedback() {
      this.showingFeedback = true;
    },
  },
};
